import { createSlice } from "@reduxjs/toolkit";
import { Container, containers } from "../db";

export type CustomContainer = {
  volume: number;
};

export const buildSavableCustomContainer = (
  customContainer: CustomContainer
): Container => {
  return {
    volume: customContainer.volume,
    units: "ml",
    type: "Own",
    ownContainer: true,
  };
};

const drinkSelection = createSlice({
  name: "selection",
  initialState: {
    drinkId: null,
    containerId: null,
    customContainer: {
      volume: 500,
    },
    eventType: undefined,
    customEvent: {
      text: undefined,
    },
  },
  reducers: {
    selectDrink: (state, action) => {
      const id = action.payload;
      state.drinkId = id;
    },
    selectContainer: (state, action) => {
      const id = action.payload;
      state.containerId = id;
    },
    setCustomContainer: (state, action) => {
      state.customContainer = action.payload;
    },
    selectEvent: (state, action) => {
      state.eventType = action.payload;
    },
    setCustomEvent: (state, action) => {
      state.customEvent = action.payload;
    },
  },
});

export const {
  selectDrink,
  selectContainer,
  setCustomContainer,
  selectEvent,
  setCustomEvent,
} = drinkSelection.actions;

export const getSelectedContainer = (state): Container | undefined => {
  const { containerId } = state;
  if (containerId === "Own")
    return buildSavableCustomContainer(state.customContainer);
  return containers.find((c) => c.id === containerId);
};

export default drinkSelection.reducer;
